import { useCallback } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { useGameDispatch } from '../../store/GameStore';
import { fetchGameConfigDataAction } from '../apiActions/fetchGameConfigDataAction';

export const useGameConfigFetcher = (force: boolean = false): (() => void) => {
  const dispatch = useGameDispatch();
  const baseUrl = useConfigSlice.baseUrl();

  return useCallback(() => {
    if (baseUrl) {
      dispatch(
        fetchGameConfigDataAction({
          url: `${window.location.origin}/apps/feature-flags/1.0.0/hf/config.json`,
          // url: `/assets/hf/config.json`,
          force: force,
        })
      );
    }
  }, [dispatch, baseUrl]);
};
